// Google Analytics 4 Measurement ID
export const TRACKING_ID: string = "G-TZ2X059FHK";
